module.exports = __webpack_public_path__ + "static/media/bicycle-blue.1da510f3.svg";